export default "__VITE_ASSET__CEi1xblO__"